import React from 'react'
//import students from '../../classes/Students.json'
import { Link } from 'react-router-dom';
import serverEndPoint from './../../dxdm'
const sideBoxes = {
    textAlign:"left",
    height: "200pt",
    width: "100%",
    backgroundColor: "rgb(233,241,246)",
    marginTop: "10%",
    marginBottom: "10%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };
function StudyWithUs() {
    return (
        <div className="container-fluid">
            <div className="row">
            <div className="col-lg-8">
                <h2 style={{ textAlign: "left", color: "#286DB5", paddingTop: "3%", paddingLeft: "3%" }}>Study with us</h2>
                <p style={{ paddingLeft: "3%", textAlign: "left", marginTop: "3%", marginBottom: "1%" }}>Our research spectrum covers all disciplines of Data Science. If you are interested to do your Master or PhD in any of the following areas, this lab is a best choice for you.</p>
                <ol style={{ textAlign: 'left', paddingLeft: "5%", listStyle: "none", listStyleImage: `url(${serverEndPoint}/images/listArrow.png)`, listStylePosition: "center",listStyleType: "square" }}>
                    <li style={{ marginTop: "0.5%", marginBottom: "0.5%" }}>Data Stream Mining and Analytics (DSMA)</li>
                    <li style={{ marginTop: "0.5%", marginBottom: "0.5%" }}>Machine Learning and Deep Learning (MLDL)</li>
                    <li style={{ marginTop: "0.5%", marginBottom: "0.5%" }}>Natural Language Processing (NLP)</li>
                    <li style={{ marginTop: "0.5%", marginBottom: "0.5%" }}>Social Data Analytics (SDA)</li>
                    <li style={{ marginTop: "0.5%", marginBottom: "0.5%" }}>Real-time Big Data Management (RDBM)</li>
                    <li style={{ marginTop: "0.5%", marginBottom: "0.5%" }}>Computer Vision (CV)</li>
                    <li style={{ marginTop: "0.5%", marginBottom: "0.5%" }}>Internet of Things (IoT)</li>
                   {/*<li style={{ marginTop: "0.5%", marginBottom: "0.5%" }}>Computational Intelligence in Sports Science</li>
                    <li style={{ marginTop: "0.5%", marginBottom: "0.5%" }}>Data Stream Mining</li>
                    <li style={{ marginTop: "0.5%", marginBottom: "0.5%" }}>Health Informatics</li>*/}
                </ol>
                <p style={{ paddingLeft: "3%", textAlign: "left" }}>A look at the projects and staff pages should give you an idea of other projects that we research on. If any of them are of interest to you, then plaease feel free to get in touch</p>
                <h3 style={{ textAlign: "left", color: "#286DB5", paddingTop: "3%", paddingLeft: "3%" }}>Scholarship and Funding</h3>
                <p style={{ paddingLeft: "3%", textAlign: "left", marginTop: "1%", marginBottom: "1%" }}>Data Insight Lab supports the members to fund for the following aims</p>
                <ol style={{ textAlign: 'left', paddingLeft: "5%" }}>
                    <li style={{ marginTop: "0.5%", marginBottom: "0.5%" }}>Master and PhD research</li>
                    <li style={{ marginTop: "0.5%", marginBottom: "0.5%" }}>Research assistantship to support a research project</li>
                    <li style={{ marginTop: "0.5%", marginBottom: "0.5%" }}>Top-up for conference travel</li>
                    <li style={{ marginTop: "0.5%", marginBottom: "0.5%" }}>Inviting visitor</li>
                </ol>
                {/*<p style={{ paddingLeft: "3%", textAlign: "left", marginTop: "1%", marginBottom: "1%" }}>Please look at the guidelines and cafetaria [PDF, 179.3 KB] before applying</p>*/}
                <p style={{ paddingLeft: "3%", textAlign: "left", marginTop: "0.5%", marginBottom: "1%" }}>Note: Application will be entertained only if funds are available</p>
                <h3 style={{ textAlign: "left", color: "#286DB5", paddingTop: "3%", paddingLeft: "3%" }}>Register your interest in studying with us</h3>
                <p style={{ paddingLeft: "3%", textAlign: "left", marginTop: "1%", marginBottom: "1%" }}>Kindly email us or simply leave a message on the contact us page and we'll get back to you.</p>
                {/*
                <h3 style={{ textAlign: "left", color: "#286DB5", paddingTop: "3%", paddingLeft: "3%" }}>Masters' degree Scholarship</h3>
                <p style={{ paddingLeft: "3%", textAlign: "left", marginTop: "1%", marginBottom: "1%" }}>Fees: $7,016 (plus up to $5000 conference costs)</p>
                <p style={{ paddingLeft: "3%", textAlign: "left", marginTop: "0.5%", marginBottom: "1%" }}>Details: Temporal and spatial pattern extraction from low to high quality videos, Towards real-time fusion for
                    wearable and ubiquitos computing devices. See more here and in this page</p>
                <p style={{ paddingLeft: "3%", textAlign: "left", marginTop: "0.5%", marginBottom: "1%" }}>Contact: Dr. Muhammad Asif Naeem</p>
                <p style={{ paddingLeft: "3%", textAlign: "left", marginTop: "0.5%", marginBottom: "1%" }}>Apply now</p>
                <h3 style={{ textAlign: "left", color: "#286DB5", paddingTop: "3%", paddingLeft: "3%" }}>PhD Scholarship</h3>
                <p style={{ paddingLeft: "3%", textAlign: "left", marginTop: "0.5%", marginBottom: "1%" }}>A fully funded PhD position is available under the Data Insight Lab at the University of Computing and Emerging Sciences (NUCES).
                    For details please visit the scholarshipt page</p>
                <p style={{ paddingLeft: "3%", textAlign: "left", marginTop: "0.5%", marginBottom: "1%" }}>Contact: Dr. Muhammad Asif Naeem</p>
                <p style={{ paddingLeft: "3%", textAlign: "left", marginTop: "0.5%", marginBottom: "1%" }}>Apply now</p>
                <p style={{ paddingLeft: "3%", textAlign: "left", marginTop: "0.5%", marginBottom: "1%" }}>In addition, there are various scholarships on offer by NUCES and Pakistan Government every year for both local and
                    international students. FOr detials, visit NUCES scholarships and awards. You can also Pakistan International Doctoral Research Scholarships</p>
                <h3 style={{ textAlign: "left", color: "#286DB5", paddingTop: "3%", paddingLeft: "3%" }}>Current students</h3>
                <ol style={{ textAlign: 'left', paddingLeft: "5%" }}>
                    {
                        students.CurrentStudents.map(data => {
                            return (<li style={{ marginTop: "0.5%", marginBottom: "0.5%" }}>{data}</li>);
                        })
                    }
                </ol>
                <h3 style={{ textAlign: "left", color: "#286DB5", paddingTop: "1.5%", paddingLeft: "3%" }}>Pasts students</h3>
                <ol style={{ textAlign: 'left', paddingLeft: "5%" }}>
                    {
                        students.PastStudents.map(data => {
                            return (<li style={{ marginTop: "0.5%", marginBottom: "0.5%" }}>{data}</li>);
                        })
                    }
                </ol>
                  */}

            </div>
            <div className="col-lg-4">
            <div style={sideBoxes}>
                <div style={{ width: "70%" }}>
                  <div>
                    <h3 style={{ color: "rgb(40,109,181)" }}>Our research</h3>
                    <p>
                      {" "}
                      Data science is an area of extensive research as new
                      applications are emerging from Industry.
                    </p>
                    <Link to= {`/our-research`}
                    // <Link to= {`${serverEndPoint}/our-research`}
                      className="btn btn-primary"
                      style={{
                        borderRadius: "20pt",
                        paddingLeft: ">0pt",
                        paddingRight: ">0pt",
                      }}
                    >
                      {" "}
                      <b>FIND OUT MORE</b>{" "}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
        </div>
        </div>
    )
}

export default StudyWithUs
